import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import GridSelect from './GridSelect';
import { getLookup } from '../../services/clinicPortalServices/lookupService';
import { MenuItem } from '@mui/material';

// Drop-in for <TextField select>{MenuItems}</TextField>: lists with 7+ options become a searchable grid; small lists stay a normal dropdown.
const flatten = (children) => {
    const out = [];
    React.Children.forEach(children, (ch) => {
        if (!ch) return;
        if (ch.type === React.Fragment) out.push(...flatten(ch.props.children));
        else out.push(ch);
    });
    return out;
};
const textOf = (n) => (typeof n === 'string' || typeof n === 'number' ? String(n) : Array.isArray(n) ? n.map(textOf).join('') : n && n.props ? textOf(n.props.children) : '');

export default function GridSelectField(props) {
    const { name, value, onChange, label, error, helperText, disabled, SelectProps, minForGrid = 7, gridColumns, select, lookup, ...rest } = props;
    let { children } = props;
    const [lookupItems, setLookupItems] = useState(null);
    useEffect(() => {
        if (!lookup) return undefined;
        let alive = true;
        getLookup(lookup).then((d) => { if (alive) setLookupItems(d || []); });
        return () => { alive = false; };
    }, [lookup]);
    if (lookup && lookupItems) children = [<MenuItem key="" value="">Please select</MenuItem>, ...lookupItems.map((i) => <MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>)];
    const items = flatten(children).filter((ch) => ch && ch.props && ch.props.value !== undefined);
    const options = items.filter((ch) => ch.props.value !== '' && !ch.props.disabled).map((ch) => ({ value: ch.props.value, label: textOf(ch.props.children) }));
    if ((SelectProps && SelectProps.multiple) || options.length < minForGrid) {
        return (
            <TextField select name={name} value={value} onChange={onChange} label={label} error={error} helperText={helperText} disabled={disabled} SelectProps={SelectProps} {...rest}>
                {children}
            </TextField>
        );
    }
    return (
        <GridSelect
            label={label}
            value={value}
            options={options}
            columns={gridColumns}
            error={error}
            helperText={helperText}
            disabled={disabled}
            placeholder="Search…"
            onChange={(v) => onChange && onChange({ target: { name, value: v }, persist: () => {} })}
        />
    );
}
